/**
 * Real-time DM: subscribe to WebSocket "dm" messages and invalidate DM queries
 * so new messages appear without refresh. Uses the same WebSocket as notifications.
 */
import { useEffect, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { notificationWebSocket } from '../lib/websocket';
import { queryKeys } from '../lib/api';

export function useRealtimeDM() {
  const queryClient = useQueryClient();

  const handleMessage = useCallback(
    (message: {
      type: string;
      data?: { message?: { conversationId?: number }; conversationId?: number };
    }) => {
      if (message.type === 'dm' && message.data?.message) {
        const convId = message.data.message.conversationId;
        if (convId != null) {
          queryClient.invalidateQueries({ queryKey: queryKeys.dmMessages(String(convId)) });
          queryClient.invalidateQueries({ queryKey: queryKeys.dmConversations });
          queryClient.invalidateQueries({ queryKey: queryKeys.dmUnreadCount });
        }
        return;
      }
      if (message.type === 'conversation_read' && message.data?.conversationId != null) {
        const convId = message.data.conversationId as number;
        queryClient.invalidateQueries({ queryKey: queryKeys.dmMessages(String(convId)) });
      }
    },
    [queryClient]
  );

  useEffect(() => {
    const unsubscribe = notificationWebSocket.onMessage(handleMessage);
    return unsubscribe;
  }, [handleMessage]);
}
